import { render, staticRenderFns } from "./AIDocumentContent.vue?vue&type=template&id=559f5d5b&scoped=true&"
import script from "./AIDocumentContent.vue?vue&type=script&lang=js&"
export * from "./AIDocumentContent.vue?vue&type=script&lang=js&"
import style0 from "./AIDocumentContent.vue?vue&type=style&index=0&id=559f5d5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f5d5b",
  null
  
)

export default component.exports